import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoadWasm } from '../LoadWasm';

import { AppManagement } from './components/app-management';
import { HelpMenuContextProvider } from '../help/HelpMenuContext/HelpMenuContext';
import { LatestVersionAutoRefresh } from './components/latest-version-auto-refresh/latest-version-auto-refresh';
import { SidebarContextProvider } from '@futrli/shared-services/contexts/sidebar-context/sidebar-context';
import { SxpContext } from '@futrli/predict';
import { useAnalyticsTrackerInit } from '../hooks/useAnalyticsTrackerInit';
import { useErrorTrackerInit } from '../hooks/useErrorTrackerInit';
import { useLaunchDarklyInit } from '../hooks/useLaunchDarklyInit';
import { UserLocaleManager } from './components/user-locale-manager';

export const AppLoggedIn: React.FC = () => {
  useErrorTrackerInit();
  useAnalyticsTrackerInit();
  useLaunchDarklyInit();

  return (
    <LoadWasm>
      <React.Fragment>
        <SxpContext>
          <SidebarContextProvider>
            <HelpMenuContextProvider>
              <UserLocaleManager />
              <LatestVersionAutoRefresh />
              <Routes>
                <Route path="*" element={<AppManagement />} />
              </Routes>
            </HelpMenuContextProvider>
          </SidebarContextProvider>
        </SxpContext>
      </React.Fragment>
    </LoadWasm>
  );
};
